import * as Sentry from "@sentry/angular";

export function logSentry(error: unknown): void {
  console.error(error);
  Sentry.captureException(error);
}
